import React, {Component}   from "react";
import {
  Panel,
  Modal,
  Button,
  Popover,
  OverlayTrigger,
  FormGroup,
  ControlLabel,
  FormControl,
  ProgressBar,
  Tooltip
}                           from "react-bootstrap";
import moment               from "moment";
import axios                from "axios";
import {
  ToastContainer,
  toast
}                           from "react-toastify";
import                           "react-toastify/dist/ReactToastify.css";

import { EVOUCHER }         from "actions/const";

import {
  IS_UNDEFINED,
  IS_EMPTY_STRING,
  IS_NULL,
  IS_VALID,
  IS_LENGTH_ZERO,
  RETRIEVE_ALL,
  GENERATE_RANDOM
}                           from "utils";

import CrudComponent        from "./../zynappse-crud";
import EVoucherSchema       from "../schema/EVoucher.js";
import saveTrail            from '../../utils/saveTrail';

import FormContainer        from "./FormContainer";

import socketIOClient     from "socket.io-client";
import FileSaver          from 'file-saver';

const WEB_PATH = window.__APP_CONFIG__.webPath || 'http://localhost:3000';

const API_KEY = window.__APP_CONFIG__.API_KEY || "89FqJepO064sVGUn";

class EVoucher extends Component {
  constructor (props) {
    super(props);

    this.refreshTableReference;

    this.exportComponentRef = React.createRef();

    this.state = {
      showModalExport: false
    };

    this.renderModalButton = this.renderModalButton.bind(this);
    this.save = this.save.bind(this);
    this.suspendData = this.suspendData.bind(this);
    this.unsuspendData = this.unsuspendData.bind(this);
    this.deleteData = this.deleteData.bind(this);
    this.refreshTable = this.refreshTable.bind(this);
    this.getRelation = this.getRelation.bind(this);
    this.getVoucherConfig = this.getVoucherConfig.bind(this);
    this.getVoucherUpdateLogs = this.getVoucherUpdateLogs.bind(this);
    this.renderModalConfigContent = this.renderModalConfigContent.bind(this);
    this.saveVoucherConfig = this.saveVoucherConfig.bind(this);
    this.uploadSpecificUserCSVFile = this.uploadSpecificUserCSVFile.bind(this);
    this.runCronJobs = this.runCronJobs.bind(this);
    this.checkEVoucherStatus = this.checkEVoucherStatus.bind(this);
    this.accessible = this.accessible.bind(this);
  }

  refreshTable () {
    if (IS_VALID(this.refreshTableReference) && typeof this.refreshTableReference === 'function') {
      this.refreshTableReference();
    }
  }

  loadOptions (input, cb, className, columnName, sortColumn = columnName) {
    let query,
        objectItem = (item) => {
          let json = {
            label: item.get(columnName),
            value: item.id
          };

          if (
            className === "VoucherValidityType" ||
            className === "VoucherType"
          ) {
            json.shortName = item.get("shortName");
          }

          return json;
        };

    if (className === "MemberDetail") {
      let query1 = new Parse.Query(className),
          query2 = new Parse.Query(className);

      query1.matches("memberId", input, "i");

      query2.matches("name", input, "i");

      query = Parse.Query.or(query1, query2);

      query.exists("memberId");
      query.notEqualTo("memberId", "");

      query.ascending("name");

      objectItem = (item) => {
        return {
          label: `${IS_VALID(item.get("memberId")) ? item.get("memberId") : ""} ${IS_VALID(item.get("name")) ? item.get("name") : ""}`,
          value: item.id
        }
      };
    } else if (className === "User") {
      query = new Parse.Query(Parse.User);

      query.equalTo("userType", "MERCHANT");
      query.matches(columnName, input.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
      query.ascending(sortColumn);
    } else if (className === "CampaignCategory") {
      query = new Parse.Query(className);
      
      query.matches(columnName, input.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
      query.ascending(sortColumn);

      objectItem = (item) => {
        let json = {
          label: item.get(columnName),
          value: item.id
        };

        // let additionalColumns = [
        //   "descriptions",
        // ];

        // for (let column of additionalColumns) {
        //   if (IS_VALID(item.get(column))) {

        //     json[column] = item.get(column);
        //   }
        // }

        return json;
      };
    } else {
      query = new Parse.Query(className);

      query.matches(columnName, input.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
      query.ascending(sortColumn);
    }

    query.limit(20);


    query.find()
    .then((data) => {
			return data.map(objectItem);
		}).then((data) => {
			cb(null, {options: data});
		})
    .catch((err) => {
      console.log('Load Select Options error: ', err.message);
    })
  }

  getRelation () {
    let {
      actions,
      EVoucher
    } = this.props;

    let {
      formType,
      selectedData
    } = EVoucher;

    let transactionTypeRelationQuery = selectedData.relation("transactionType").query(),
        sendPushNotificationRelationQuery = selectedData.relation("sendPushNotification").query(),
        cardTypeRelationQuery = selectedData.relation("cardType").query(),
        specificUserV2 = selectedData.relation("specificUserV2").query(),
        blacklistedUser = selectedData.relation("blacklistedUser").query(),
        evScannerUser = selectedData.relation("evScannerUser").query();

    transactionTypeRelationQuery.ascending("name");
    sendPushNotificationRelationQuery.ascending("count");
    cardTypeRelationQuery.ascending("name");
    specificUserV2.ascending("name");
    blacklistedUser.ascending("name");
    evScannerUser.ascending("name");

    return Promise.all([
      transactionTypeRelationQuery.find(),
      sendPushNotificationRelationQuery.find(),
      cardTypeRelationQuery.find(),
      RETRIEVE_ALL(specificUserV2),
      RETRIEVE_ALL(blacklistedUser),
      RETRIEVE_ALL(evScannerUser)
    ]);
  }

  save (isDraft = false) {
    let {
      EVoucher,
      actions
    } = this.props;

    let {
      selectedData,
      formType,
      formId,

      typeK,
      transactionType,
      cardType,
      pointType,
      deductPointType,
      birthMonth,
      tdd_birthMonthStartDate,
      tdd_birthMonthEndDate,
      campaignStartDate,
      campaignEndDate,
      requiredEarningAmount,
      deductPointAmount,
      maxVoucherQuantity,
      maxVoucherQuantityPerDay,
      maxVoucherQuantityPerUser,
      maxVoucherQuantityPerUserPerDay,
      welcomeDays,
      version,
      campaignCategory,
      title,
      promotionName,
      descriptions,
      whereToRedeem,
      evScannerUser,
      manualDispense,
      serialNumberPrefix,
      amount,
      promoOwnerCostCenter,
      promoCategory,
      nnsl_amount,
      nnc_amount,
      image,
      isShowForFirstTimeUsers,
      isShowRemainingQuantity,
      isRateRequired,
      isShowMerchantsOwnRedemptionOnly,

      sendPushNotification,
      earningPeriod,
      earningPeriodStartDate,
      earningPeriodEndDate,

      voucherValidityType,
      voucherValidityDays,
      voucherValidityHour,
      voucherValidityMinute,
      voucherValiditySecond,
      voucherValidityStartDate,
      voucherValidityEndDate,
      voucherValidityStartTime,
      voucherValidityEndTime,
      voucherValidityIsUseCalendarDay,

      rateTimeConfigHour,
      rateTimeConfigMinute,
      rateTimeConfigSecond,

      specificUser,
      blacklistedUser,

      gender
    } = EVoucher;

    let isDateRange = IS_VALID(earningPeriod) && earningPeriod.label.toUpperCase() === "DATE RANGE";
    let isEVoucherPublished = formType !== "DUPLICATE" &&
                              IS_VALID(selectedData) &&
                              IS_VALID(selectedData.get("status")) &&
                              (selectedData.get("status") === "PUBLISH" || selectedData.get("status") === "EXPIRED" || selectedData.get("status") === "SUSPENDED") &&
                              (IS_VALID(campaignStartDate) ? true : false) &&
                              (IS_VALID(selectedData.get("campaignStartDate")) && moment(selectedData.get("campaignStartDate")).isSameOrBefore(moment()));

    // (IS_VALID(selectedData.get("campaignStartDate")) && moment(selectedData.get("campaignStartDate"), "YYYY-MM-DD").isSameOrBefore(moment(moment().format("YYYY-MM-DD"), "YYYY-MM-DD")));

    // else if (
    //   !isDraft &&
    //   IS_VALID(campaignStartDate) &&
    //   IS_VALID(campaignEndDate) &&
    //   moment(campaignStartDate, "YYYY-MM-DD").isSameOrAfter(moment(campaignEndDate, "YYYY-MM-DD"))
    // ) {
    //   toast.error("Campaign Start Date should not be equal or greater than Campaign End Date");
    // } else if (
    //   !isDraft &&
    //   IS_VALID(campaignEndDate) &&
    //   moment(moment(), "YYYY-MM-DD").isSameOrBefore(moment(campaignStartDate, "YYYY-MM-DD"))) {
    //   toast.error("Campaign End Date should be greater than the date today.");
    // }

    let getTotalVoucherValidity = (
      hour,
      minute,
      second,
      text = "Voucher Validity"
    ) => {
      let totalVoucherValidity = 0;

      if (IS_VALID(hour) && parseFloat(hour) % 1 !== 0) {
        return "Hour should be a whole number.";
      } else if (IS_VALID(hour) && parseInt(hour) > 0) {
        totalVoucherValidity += parseInt(hour);
      }

      if (IS_VALID(minute) && parseFloat(minute) % 1 !== 0) {
        return "Minute should be a whole number.";
      } else if (IS_VALID(minute) && parseInt(minute) > 0) {
        totalVoucherValidity += parseInt(minute);
      }

      if (IS_VALID(second) && parseFloat(second) % 1 !== 0) {
        return "Second should be a whole number.";
      } else if (IS_VALID(second) && parseInt(second) > 0) {
        totalVoucherValidity += parseInt(second);
      }

      if (totalVoucherValidity <= 0) {
        return `Total ${text} is zero.`;
      }

      return false;
    };

    let getTotalVoucherValidityResult = getTotalVoucherValidity(voucherValidityHour, voucherValidityMinute, voucherValiditySecond);

    let getVoucherValidityDateRange = () => {
      if (!IS_VALID(voucherValidityStartDate)) {
        return "Voucher Validity Start Date is required.";
      } else if (!moment(voucherValidityStartDate, "MMM DD, YYYY hh:mm A", true).isValid()) {
        return "Please select a valid Voucher Validity Start Date.";
      } else if (!isEVoucherPublished && moment(voucherValidityStartDate, "MMM DD, YYYY hh:mm A", true).isBefore(moment(), "day")) {
        return "Voucher Validity Start Date should be greater than or equal to the date today.";
      } else if (!IS_VALID(voucherValidityEndDate)) {
        return "Voucher Validity End Date is required.";
      } else if (!moment(voucherValidityEndDate, "MMM DD, YYYY hh:mm A", true).isValid()) {
        return "Please select a valid Voucher Validity End Date.";
      } else if (moment(voucherValidityEndDate, "MMM DD, YYYY hh:mm A", true).isBefore(moment(), "day")) {
        return "Voucher Validity End Date should be greater than or equal to the date today.";
      } else if (
        moment(voucherValidityEndDate, "MMM DD, YYYY hh:mm A", true).isBefore(moment(voucherValidityStartDate, "MMM DD, YYYY hh:mm A", true))
      ) {
        return "Voucher Validity End Date should be greater than Voucher Validity Start Date.";
      } else if (
        moment(voucherValidityEndDate, "MMM DD, YYYY hh:mm A", true).isSame(moment(voucherValidityStartDate, "MMM DD, YYYY hh:mm A", true))
      ) {
        return "Voucher Validity Start Date and Voucher Validity End Date should not be the same.";
      }

      return false;
    };

    let getVoucherValidityDateRangeResult = getVoucherValidityDateRange();

    let getVoucherValidityTime = () => {
      let month = moment().month(),
          date = moment().date(),
          year = moment().year();

      if (!IS_VALID(voucherValidityStartTime)) {
        return "Voucher Validity Start Time is required.";
      } else if (
        !moment(voucherValidityStartTime, "hh:mm A", true).isValid()
      ) {
        return "Please select a valid Voucher Validity Start Time.";
      } else if (!IS_VALID(voucherValidityEndTime)) {
        return "Voucher Validity End Time is required.";
      } else if (
        !moment(voucherValidityEndTime, "hh:mm A", true).isValid()
      ) {
        return "Please select a valid Voucher Validity End Time.";
      } else if (
        moment(voucherValidityEndTime, "hh:mm A", true).month(month).date(date).year(year).isBefore(moment(voucherValidityStartTime, "hh:mm A", true).month(month).date(date).year(year))
      ) {
        return "Voucher Validity End Time should be greater Voucher Validity Start Time";
      } else if (
        moment(voucherValidityEndTime, "hh:mm A", true).month(month).date(date).year(year).isSame(moment(voucherValidityStartTime, "hh:mm A", true).month(month).date(date).year(year))
      ) {
        return "Voucher Validity Start Time and Voucher Validity End Time should not be the same.";
      } else if (
        !voucherValidityIsUseCalendarDay &&
        moment(voucherValidityStartTime, "hh:mm A", true).month(month).date(date).year(year).isBetween(moment("12:00 AM", "hh:mm A", true).month(month).date(date).year(year).subtract(1, "minutes"), moment("03:59 AM", "hh:mm A", true).month(month).date(date).year(year)) ||
        moment(voucherValidityEndTime, "hh:mm A", true).month(month).date(date).year(year).isBetween(moment("12:00 AM", "hh:mm A", true).month(month).date(date).year(year).subtract(1, "minutes"), moment("03:59 AM", "hh:mm A", true).month(month).date(date).year(year))
      ) {
        return "Voucher Validity Time should not start/end between 12: 00 AM and 03:59 AM";
      }

      return false;
    };

    let getVoucherValidityDaysTime = () => {
      let month = moment().month(),
          date = moment().date(),
          year = moment().year();

      if (!IS_VALID(voucherValidityDays)) {
        return "Voucher Validity Days is required.";
      } else if (parseInt(voucherValidityDays) <= 0) {
        return "Voucher Validity Days should be greater than zero.";
      } else if (!IS_VALID(voucherValidityEndTime)) {
        return "Voucher Validity End Time is required.";
      } else if (
        !moment(voucherValidityEndTime, "hh:mm A", true).isValid()
      ) {
        return "Please select a valid Voucher Validity End Time.";
      } else if (
        !voucherValidityIsUseCalendarDay &&
        moment(voucherValidityEndTime, "hh:mm A", true).month(month).date(date).year(year).isBetween(moment("12:00 AM", "hh:mm A", true).month(month).date(date).year(year).subtract(1, "minutes"), moment("03:59 AM", "hh:mm A", true).month(month).date(date).year(year))
      ) {
        return "Voucher Validity End Time should not end between 12: 00 AM and 03:59 AM";
      }

      return false;
    };

    let getVoucherValidityTimeResult = getVoucherValidityTime();

    let getVoucherValidityDaysTimeResult = getVoucherValidityDaysTime();

    let getTotalRateConfigTimeResult = getTotalVoucherValidity(rateTimeConfigHour, rateTimeConfigMinute, rateTimeConfigSecond, "Time before Rate form show");

    const checkVoucherType = (shortName) => (
      IS_VALID(typeK) &&
      IS_VALID(typeK.shortName) &&
      typeK.shortName.toUpperCase() === shortName
    );

    let isWelcomeVoucher = checkVoucherType("W"),
        isBirthdayVoucher = checkVoucherType("B");

    let totalCampaignDays = 0;

    if (
      IS_VALID(campaignStartDate) &&
      moment(campaignStartDate, "MMM DD, YYYY hh:mm A", true).isValid() &&
      IS_VALID(campaignEndDate) &&
      moment(campaignEndDate, "MMM DD, YYYY hh:mm A", true).isValid()
    ) {
      let totalDays = moment(moment(campaignEndDate, "MMM DD, YYYY hh:mm A", true).startOf("day")).diff(moment(campaignStartDate, "MMM DD, YYYY hh:mm A", true).startOf("day"), "days") + 1;

      if (totalDays >= 0) {
        totalCampaignDays = totalDays;
      }
    }

    if (!isDraft && !IS_VALID(typeK)) {
      toast.error("Type K is required.");
    } else if (!isDraft && !IS_VALID(gender)) {
      toast.error("Gender is required.");
    } else if (!isDraft && IS_VALID(pointType) && !IS_VALID(requiredEarningAmount)) {
      toast.error("Required Earning Amount is required.");
    } else if (!isDraft && IS_VALID(deductPointType) && !IS_VALID(deductPointAmount)) {
      toast.error("Deduct Point Amount is required.");
    } else if (!isDraft && !IS_VALID(maxVoucherQuantity)) {
      toast.error("Max Voucher Quantity is required.");
    } else if (!isDraft && IS_VALID(maxVoucherQuantity) && parseInt(maxVoucherQuantity) <= 0) {
      toast.error("Max Voucher Quantity should be greater than zero.");
    } else if (!isDraft && !IS_VALID(maxVoucherQuantityPerDay)) {
      toast.error("Max Voucher Quantity Per Day is required.");
    } else if (!isDraft && IS_VALID(maxVoucherQuantityPerDay) && parseInt(maxVoucherQuantityPerDay) <= 0) {
      toast.error("Max Voucher Quantity Per Day should be greater than zero.");
    } else if (!isDraft && parseInt(maxVoucherQuantityPerDay) > parseInt(maxVoucherQuantity)) {
      toast.error("Max Voucher Quantity Per Day should not be greater than the Max Voucher Quantity.");
    } else if (!isDraft && !IS_VALID(maxVoucherQuantityPerUser)) {
      toast.error("Max Voucher Quantity Per User is required.");
    } else if (!isDraft && IS_VALID(maxVoucherQuantityPerUser) && parseInt(maxVoucherQuantityPerUser) <= 0) {
      toast.error("Max Voucher Quantity Per User should be greater than zero.");
    } else if (!isDraft && parseInt(maxVoucherQuantityPerUser) > parseInt(maxVoucherQuantity)) {
      toast.error("Max Voucher Quantity Per User should not be greater than the Max Voucher Quantity.");
    } else if (!isDraft && !IS_VALID(maxVoucherQuantityPerUserPerDay)) {
      toast.error("Max Voucher Quantity Per User Per Day is required.");
    } else if (!isDraft && IS_VALID(maxVoucherQuantityPerUserPerDay) && parseInt(maxVoucherQuantityPerUserPerDay) <= 0) {
      toast.error("Max Voucher Quantity Per User Per Day should be greater than zero.");
    } else if (!isDraft && parseInt(maxVoucherQuantityPerUserPerDay) > parseInt(maxVoucherQuantityPerUser)) {
      toast.error("Max Voucher Quantity Per User Per Day should be greater than the Max Voucher Quantity Per User.");
    }
    else if (!isDraft && !IS_VALID(version)) {
      toast.error("Voucher Version is required.");
    } else if (!isDraft && !IS_VALID(campaignCategory) && version.value == 2) {
      toast.error("Campaign Category is required.");
    }
    else if (
      !isDraft &&
      IS_VALID(version) &&
      version.value === 1 &&
      !IS_VALID(earningPeriod)
    ) {
      toast.error("Earning Period is required.");
    } else if (!isDraft && isDateRange && !IS_VALID(earningPeriodStartDate)) {
      toast.error("Earning Period Start Date is required.");
    } else if (!isDraft && isDateRange && !moment(earningPeriodStartDate, "MMM DD, YYYY", true).isValid()) {
      toast.error("Please select a valid Earning Period Start Date.");
    } else if (!isDraft && isDateRange && !IS_VALID(earningPeriodEndDate)) {
      toast.error("Earning Period End Date is required.");
    } else if (!isDraft && isDateRange && !moment(earningPeriodEndDate, "MMM DD, YYYY", true).isValid()) {
      toast.error("Please select a valid Earning Period End Date.");
    }
    else if (
      !isDraft &&
      isBirthdayVoucher &&
      !IS_VALID(birthMonth)
    ) {
      toast.error("Birth Month is required.");
    } else if (
      !isDraft &&
      isBirthdayVoucher &&
      birthMonth.value < moment().month()
    ) {
      toast.error("Birth Month should be greater than or equal to the current month.");
    }

    else if (!isDraft && !IS_VALID(campaignStartDate)) {
      toast.error("Campaign Start Date is required.");
    } else if (!isDraft && !moment(campaignStartDate, "MMM DD, YYYY hh:mm A", true).isValid()) {
      toast.error("Please select a valid Campaign Start Date");
    } else if (
      !isDraft &&
      !isEVoucherPublished &&
      !isBirthdayVoucher &&
      IS_VALID(campaignStartDate) &&
      moment(campaignStartDate, "MMM DD, YYYY hh:mm A", true).isBefore(moment(), "day")
    ) {
      toast.error("Campaign Start Date should be greater than or equal to the date today.");
    } else if (!isDraft && !IS_VALID(campaignEndDate)) {
      toast.error("Campaign End Date is required.");
    } else if (!isDraft && !moment(campaignEndDate, "MMM DD, YYYY hh:mm A", true).isValid()) {
      toast.error("Please select a valid Campaign End Date");
    } else if (!isDraft && IS_VALID(campaignEndDate) && moment(campaignEndDate, "MMM DD, YYYY hh:mm A", true).isSameOrBefore(moment())) {
      toast.error("Campaign End Date should be greater than the date today.");
    } else if (
      !isDraft &&
      IS_VALID(campaignStartDate) &&
      IS_VALID(campaignEndDate) &&
      moment(campaignEndDate, "MMM DD, YYYY hh:mm A", true).isBefore(moment(campaignStartDate, "MMM DD, YYYY hh:mm A", true))
    ) {
      toast.error("Campaign End Date should be greater than Campaign Start Date.");
    } else if (
      !isDraft &&
      IS_VALID(campaignStartDate) &&
      IS_VALID(campaignEndDate) &&
      moment(campaignEndDate, "MMM DD, YYYY hh:mm A", true).isSame(moment(campaignStartDate, "MMM DD, YYYY hh:mm A", true))
    ) {
      toast.error("Campaign Start Date and Campaign End Date should not be the same.");
    }
    else if (
      !isDraft &&
      IS_VALID(campaignStartDate) &&
      moment(campaignStartDate, "MMM DD, YYYY hh:mm A", true).isBefore(campaignCategory.get("campaignStartDate"))
    ) {
      toast.error("Campaign Start Date should be greater than or equal to Campaign Category Start Date.");
    } else if (
      !isDraft &&
      IS_VALID(campaignEndDate) &&
      moment(campaignEndDate, "MMM DD, YYYY hh:mm A", true).isAfter(campaignCategory.get("campaignEndDate"))
    ) {
      toast.error("Campaign End Date should be less than or equal to Campaign Category End Date.");
    }
    else if (
      !isDraft &&
      isDateRange &&
      IS_VALID(earningPeriodStartDate) &&
      IS_VALID(campaignStartDate) &&
      moment(earningPeriodStartDate, "MMM DD, YYYY", true).isBefore(moment(campaignStartDate, "MMM DD, YYYY hh:mm A", true), "day")
    ) {
      toast.error("Earning Period Start Date should be greater than or equal to Campaign Start Date.");
    } else if (
      !isDraft &&
      isDateRange &&
      IS_VALID(earningPeriodEndDate) &&
      IS_VALID(campaignEndDate) &&
      moment(earningPeriodEndDate, "MMM DD, YYYY", true).isAfter(moment(campaignEndDate, "MMM DD, YYYY hh:mm A", true), "day")
    ) {
      toast.error("Earning Period End Date should be less than or equal to Campaign End Date.");
    } else if (
      !isDraft &&
      isDateRange &&
      IS_VALID(earningPeriodStartDate) &&
      IS_VALID(earningPeriodEndDate) &&
      moment(earningPeriodEndDate, "MMM DD, YYYY", true).isBefore(moment(earningPeriodStartDate, "MMM DD, YYYY", true))
    ) {
      toast.error("Earning Period End Date should be greater than Earning Period Start Date.");
    }
    else if (
      !isDraft &&
      !isBirthdayVoucher &&
      !IS_VALID(voucherValidityType)
    ) {
      toast.error("Voucher Validity Type is required.");
    } else if (
      !isDraft &&
      !isBirthdayVoucher &&
      voucherValidityType.shortName === "T" &&
      getTotalVoucherValidityResult
    ) {
      toast.error(getTotalVoucherValidityResult);
    } else if (
      !isDraft &&
      !isBirthdayVoucher &&
      voucherValidityType.shortName === "DR" &&
      getVoucherValidityDateRangeResult
    ) {
      toast.error(getVoucherValidityDateRangeResult);
    } else if (
      !isDraft &&
      !isBirthdayVoucher &&
      voucherValidityType.shortName === "SDT" &&
      getVoucherValidityTimeResult
    ) {
      toast.error(getVoucherValidityTimeResult);
    } else if (
      !isDraft &&
      !isBirthdayVoucher &&
      voucherValidityType.shortName === "DT" &&
      getVoucherValidityDaysTimeResult
    ) {
      toast.error(getVoucherValidityDaysTimeResult);
    } else if (
      !isDraft &&
      !isBirthdayVoucher &&
      (
        voucherValidityType.shortName === "SDT" ||
        voucherValidityType.shortName === "DR"
      ) &&
      voucherValidityIsUseCalendarDay &&
      (
        IS_VALID(requiredEarningAmount) &&
        parseInt(requiredEarningAmount) !== 0
      )
    ) {
      toast.error('Requried Earning Amount should be zero when Use Calendar Day is checked.')
    } else if (
      !isDraft &&
      isWelcomeVoucher &&
      !IS_VALID(welcomeDays)
    ) {
      toast.error("Welcome Days is required.");
    } else if (
      !isDraft &&
      isWelcomeVoucher &&
      IS_VALID(welcomeDays) &&
      parseInt(welcomeDays) <= 0
    ) {
      toast.error("Welcome Days should be greater than zero.");
    } else if (
      !isDraft &&
      isWelcomeVoucher &&
      IS_VALID(welcomeDays) &&
      parseInt(welcomeDays) > totalCampaignDays
    ) {
      toast.error("Welcome Days should be less than or equal to Campaign Days.");
    } else if (!isDraft && (IS_LENGTH_ZERO(cardType) && IS_LENGTH_ZERO(specificUser))) {
      toast.error("You must provide either Card Type or Specific User.");
    } else if (!isDraft && !IS_VALID(title.trim())) {
      toast.error("Title is required.");
    } else if (!isDraft && !IS_VALID(descriptions.trim())) {
      toast.error("Description is required.");
    } else if (!isDraft && !IS_VALID(whereToRedeem.trim())) {
      toast.error("Where to Redeem is required.");
    } else if (!isDraft && Array.isArray(evScannerUser) && evScannerUser.length === 0) {
      toast.error("EV Scanner User is required.");
    } else if (!isDraft && !IS_VALID(serialNumberPrefix)) {
      toast.error("Serial Number Prefix is required.");
    } else if (!isDraft && IS_VALID(serialNumberPrefix) && (serialNumberPrefix.length < 3 || serialNumberPrefix.length > 3)) {
      toast.error("Serial Number Prefix should be 3 character in length.");
    } else if (!isDraft && !IS_VALID(amount)) {
      toast.error("Budget Amount is required.");
    } else if (!isDraft && IS_VALID(amount) && parseInt(amount) <= 0) {
      toast.error("Budget Amount should be greater than zero.");
    } else if (!isDraft && !IS_VALID(promoOwnerCostCenter)) {
      toast.error("Promo Owner Cost Center is required.");
    } else if (!isDraft && !IS_VALID(promoCategory)) {
      toast.error("Promo Category is required.");
    } else if (!isDraft && IS_VALID(nnsl_amount) && parseInt(nnsl_amount) <= 0) {
      toast.error("NNSL Amount should be greater than zero.");
    } else if (!isDraft && IS_VALID(nnc_amount) && parseInt(nnc_amount) <= 0) {
      toast.error("NNC Amount should be greater than zero.");
    } else if (isRateRequired && getTotalRateConfigTimeResult) {
      toast.error(getTotalRateConfigTimeResult);
    } else {
      let fd = new FormData();

      let dataToAppend = {
        userId: Parse.User.current().id,
        status: (
          isDraft ? (
            "DRAFT"
          ) : IS_VALID(selectedData) && IS_VALID(selectedData.get("status")) && selectedData.get("status") === "SUSPENDED" ? (
            "SUSPENDED"
          ) : (
            "PUBLISH"
          )
        ),

        
        isShowForFirstTimeUsers,
        isShowRemainingQuantity,
        isRateRequired,
        isShowMerchantsOwnRedemptionOnly,
        voucherValidityIsUseCalendarDay
      };

      if (IS_VALID(typeK) && IS_VALID(typeK.value)) {
        dataToAppend.typeKId = typeK.value;

        dataToAppend.typeK_shortName = typeK.shortName;
      }

      if (IS_VALID(gender) && IS_VALID(gender.value)) {
        dataToAppend.gender = gender.value;
      }

      if (IS_VALID(transactionType) && Array.isArray(transactionType)) {
        for (let index in transactionType) {
          fd.append(`transactionTypeIdArray[${index}]`, transactionType[index].value || "");
        }
      }

      if (IS_VALID(cardType) && Array.isArray(cardType) && specificUser.length === 0) {
        for (let index in cardType) {
          fd.append(`cardTypeIdArray[${index}]`, cardType[index].value || "");
        }
      }

      if (IS_VALID(pointType) && IS_VALID(pointType.value)) {
        dataToAppend.pointTypeId = pointType.value;
      }

      if (IS_VALID(deductPointType) && IS_VALID(deductPointType.value)) {
        dataToAppend.deductPointTypeId = deductPointType.value;
      }

      if (IS_VALID(birthMonth) && IS_VALID(birthMonth.value)) {
        dataToAppend.birthMonth = birthMonth.value;
      }

      if (
        IS_VALID(tdd_birthMonthStartDate) &&
        moment(tdd_birthMonthStartDate).isValid()
      ) {
        dataToAppend.tdd_birthMonthStartDate = moment(tdd_birthMonthStartDate).format();
      }

      if (
        IS_VALID(tdd_birthMonthEndDate) &&
        moment(tdd_birthMonthEndDate).isValid()
      ) {
        dataToAppend.tdd_birthMonthEndDate = moment(tdd_birthMonthEndDate).format();
      }

      if (IS_VALID(campaignStartDate)) {
        dataToAppend.campaignStartDate = moment(campaignStartDate, "MMM DD, YYYY hh:mm A", true).format();
      }

      if (IS_VALID(campaignEndDate)) {
        dataToAppend.campaignEndDate = moment(campaignEndDate, "MMM DD, YYYY hh:mm A", true).format();
      }

      if (IS_VALID(requiredEarningAmount)) {
        dataToAppend.requiredEarningAmount = requiredEarningAmount;
      }

      if (IS_VALID(deductPointAmount)) {
        dataToAppend.deductPointAmount = deductPointAmount;
      }

      if (IS_VALID(maxVoucherQuantity)) {
        dataToAppend.maxVoucherQuantity = maxVoucherQuantity;
      }

      if (IS_VALID(maxVoucherQuantityPerDay)) {
        dataToAppend.maxVoucherQuantityPerDay = maxVoucherQuantityPerDay;
      }

      if (IS_VALID(maxVoucherQuantityPerUser)) {
        dataToAppend.maxVoucherQuantityPerUser = maxVoucherQuantityPerUser;
      }

      if (IS_VALID(maxVoucherQuantityPerUserPerDay)) {
        dataToAppend.maxVoucherQuantityPerUserPerDay = maxVoucherQuantityPerUserPerDay;
      }

      if (IS_VALID(welcomeDays)) {
        dataToAppend.welcomeDays = welcomeDays;
      }

      if (IS_VALID(voucherValidityDays)) {
        dataToAppend.voucherValidityDays = voucherValidityDays;
      }

      if (IS_VALID(voucherValidityType) && IS_VALID(voucherValidityType.value)) {
        dataToAppend.voucherValidityTypeId = voucherValidityType.value;

        dataToAppend.voucherValidityType_shortName = voucherValidityType.shortName;
      }

      if (IS_VALID(voucherValidityHour) && parseInt(voucherValidityHour) > 0) {
        dataToAppend.voucherValidityHour = parseInt(voucherValidityHour);
      }

      if (IS_VALID(voucherValidityMinute) && parseInt(voucherValidityMinute) > 0) {
        dataToAppend.voucherValidityMinute = parseInt(voucherValidityMinute);
      }

      if (IS_VALID(voucherValiditySecond) && parseInt(voucherValiditySecond) > 0) {
        dataToAppend.voucherValiditySecond = parseInt(voucherValiditySecond);
      }

      let month = moment().month(),
          date = moment().date(),
          year = moment().year();
          
      if (
        IS_VALID(voucherValidityStartTime) &&
        moment(voucherValidityStartTime, "hh:mm A", true).isValid()
      ) {
        dataToAppend.voucherValidityStartTime = moment(voucherValidityStartTime, "hh:mm A", true).month(month).date(date).year(year).format();

        dataToAppend.voucherValidityStartTime_string = moment(voucherValidityStartTime, "hh:mm A", true).month(month).date(date).year(year).format("hh:mm A");
      }

      if (
        IS_VALID(voucherValidityEndTime) &&
        moment(voucherValidityEndTime, "hh:mm A", true).isValid()
      ) {
        dataToAppend.voucherValidityEndTime = moment(voucherValidityEndTime, "hh:mm A", true).month(month).date(date).year(year).format();
        
        dataToAppend.voucherValidityEndTime_string = moment(voucherValidityEndTime, "hh:mm A", true).month(month).date(date).year(year).format("hh:mm A");
      }

      if (isRateRequired) {
        if (IS_VALID(rateTimeConfigHour) && parseInt(rateTimeConfigHour) > 0) {
          dataToAppend.rateTimeConfigHour = parseInt(rateTimeConfigHour);
        }

        if (IS_VALID(rateTimeConfigMinute) && parseInt(rateTimeConfigMinute) > 0) {
          dataToAppend.rateTimeConfigMinute = parseInt(rateTimeConfigMinute);
        }

        if (IS_VALID(rateTimeConfigSecond) && parseInt(rateTimeConfigSecond) > 0) {
          dataToAppend.rateTimeConfigSecond = parseInt(rateTimeConfigSecond);
        }
      }

      if (IS_VALID(voucherValidityStartDate)) {
        dataToAppend.voucherValidityStartDate = moment(voucherValidityStartDate, "MMM DD, YYYY hh:mm A", true).format();
      }

      if (IS_VALID(voucherValidityEndDate)) {
        dataToAppend.voucherValidityEndDate = moment(voucherValidityEndDate, "MMM DD, YYYY hh:mm A", true).format();
      }

      if (IS_VALID(specificUser) && Array.isArray(specificUser) && cardType.length === 0) {
        for (let index in specificUser) {
          fd.append(`specificUserIdArray[${index}]`, specificUser[index].value || "");
        }
      }

      if (IS_VALID(blacklistedUser) && Array.isArray(blacklistedUser)) {
        for (let index in blacklistedUser) {
          fd.append(`blacklistedUserIdArray[${index}]`, blacklistedUser[index].value || "");
        }
      }

      if (IS_VALID(version) && IS_VALID(version.value)) {
        dataToAppend.version = version.value;
      }

      if (IS_VALID(campaignCategory)) {
        dataToAppend.campaignCategoryId = campaignCategory.id;
      }

      if (IS_VALID(title)) {
        dataToAppend.title = title;
      }

      if (IS_VALID(promotionName)) {
        dataToAppend.promotionName = promotionName;
      }

      if (IS_VALID(descriptions)) {
        dataToAppend.descriptions = descriptions;
      }

      if (IS_VALID(whereToRedeem)) {
        dataToAppend.whereToRedeem = whereToRedeem;
      }

      if (IS_VALID(evScannerUser) && Array.isArray(evScannerUser)) {
        for (let index in evScannerUser) {
          fd.append(`evScannerUserIdArray[${index}]`, evScannerUser[index].value || "");
        }
      }

      // if (IS_VALID(manualDispense)) {
      //   dataToAppend.manualDispense = manualDispense;
      // }

      if (IS_VALID(serialNumberPrefix)) {
        dataToAppend.serialNumberPrefix = serialNumberPrefix;
      }

      if (IS_VALID(amount)) {
        dataToAppend.amount = amount;
      }

      if (IS_VALID(promoOwnerCostCenter)) {
        dataToAppend.promoOwnerCostCenter = promoOwnerCostCenter;
      }

      if (IS_VALID(promoCategory) && IS_VALID(promoCategory.value)) {
        dataToAppend.promoCategoryId = promoCategory.value;
      }

      if (IS_VALID(nnsl_amount)) {
        dataToAppend.nnsl_amount = nnsl_amount;
      }

      if (IS_VALID(nnc_amount)) {
        dataToAppend.nnc_amount = nnc_amount;
      }
      
      if (IS_VALID(image)) {
        if (IS_VALID(image.isOld) && image.isOld) {
          if (formType === "DUPLICATE") {
            let imageJSON = selectedData.get("image").toJSON();

            for (let key in imageJSON) {
              fd.append(`image_duplicate[${key}]`, imageJSON[key]);
            }
          } else {
            dataToAppend.isImageChange = false;
          }
        } else {
          dataToAppend.image = image;
        }
      }

      if (IS_VALID(sendPushNotification) && Array.isArray(sendPushNotification)) {
        for (let index in sendPushNotification) {
          fd.append(`sendPushNotificationIdArray[${index}]`, sendPushNotification[index].value || "");
        }
      }

      if (IS_VALID(earningPeriod) && IS_VALID(earningPeriod.value)) {
        dataToAppend.earningPeriodId = earningPeriod.value;

        if (isDateRange) {
          if (IS_VALID(earningPeriodStartDate)) {
            dataToAppend.earningPeriodStartDate = moment(earningPeriodStartDate).hour(4).minute(0).format(); // startOf("d")
          }
    
          if (IS_VALID(earningPeriodEndDate)) {
            dataToAppend.earningPeriodEndDate = moment(earningPeriodEndDate).endOf("d").format(); // hour(3).minute(59).second(59)
          }
        }
      }

      for (let key in dataToAppend) {
        fd.append([key], dataToAppend[key]);
      }

      let httpMethod = "post",
          url = `${WEB_PATH}/EVoucher`;

      if ((!IS_EMPTY_STRING(formType) && formType.toUpperCase() === "UPDATE") && !IS_EMPTY_STRING(formId)) {
        httpMethod = "put";
        url = `${url}/${formId}`;
      }

      actions.setValue(EVOUCHER, { isLoadingAction: true });

      axios[httpMethod](url, fd)
      .then((res) => {
        let changesObject = {};
          
        if (res.data.changesObject) {
          changesObject = res.data.changesObject;

          let keys = Object.keys(res.data.changesObject);
          
          if (
            keys.indexOf("typeK") &&
            IS_VALID(typeK) &&
            IS_VALID(typeK.label)
          ) {
            changesObject.typeK = typeK.label;
          }

          if (
            keys.indexOf("pointType") &&
            IS_VALID(pointType) &&
            IS_VALID(pointType.label)
          ) {
            changesObject.pointType = pointType.label;
          }

          if (
            keys.indexOf("deductPointType") &&
            IS_VALID(deductPointType) &&
            IS_VALID(deductPointType.label)
          ) {
            changesObject.deductPointType = deductPointType.label;
          }

          if (
            keys.indexOf("earningPeriod") &&
            IS_VALID(earningPeriod) &&
            IS_VALID(earningPeriod.label)
          ) {
            changesObject.earningPeriod = earningPeriod.label;
          }

          if (
            keys.indexOf("version") &&
            IS_VALID(version) &&
            IS_VALID(version.label)
          ) {
            changesObject.version = version.label;
          }

          if (
            keys.indexOf("campaignCategory") &&
            IS_VALID(campaignCategory) &&
            IS_VALID(campaignCategory.get("title"))
          ) {
            changesObject.campaignCategory = campaignCategory.get("title");
          }
        }
        
        actions.setValue(
          EVOUCHER,
          {
            isLoadingAction: false,
            showModal: false
          }
        );

        this.refreshTable();

        saveTrail(formType.toUpperCase(), changesObject);
      })
      .catch((err) => {
        console.log("err", err);

        actions.setValue(
          EVOUCHER,
          {
            isLoadingAction: false,
            showModal: false
          }
        );

        this.refreshTable();
      });
    }
  }

  suspendData () {
    let {
      EVoucher,
      actions
    } = this.props;

    let {
      selectedData,
      formType,
      formId
    } = EVoucher;

    actions.setValue(EVOUCHER, { isLoadingAction: true });

    axios.post(
      WEB_PATH + "/EVoucher/suspend/" + selectedData.id
    )
    .then((res) => {
      actions.setValue(
        EVOUCHER,
        {
          isLoadingAction: false,
          showModal: false
        }
      );

      this.refreshTable();

      saveTrail(
        formType.toUpperCase(),
        {
          id: selectedData.id,
          title: selectedData.get("title")
        }
      );
    })
    .catch((err) => {
      console.log("err", err);

      actions.setValue(
        EVOUCHER,
        {
          isLoadingAction: false,
          showModal: false
        }
      );

      this.refreshTable();
    });
  }

  unsuspendData () {
    let {
      EVoucher,
      actions
    } = this.props;

    let {
      selectedData,
      formType,
      formId
    } = EVoucher;

    actions.setValue(EVOUCHER, { isLoadingAction: true });

    axios.post(
      WEB_PATH + "/EVoucher/unsuspend/" + selectedData.id
    )
    .then((res) => {
      actions.setValue(
        EVOUCHER,
        {
          isLoadingAction: false,
          showModal: false
        }
      );

      this.refreshTable();

      saveTrail(
        formType.toUpperCase(),
        {
          id: selectedData.id,
          title: selectedData.get("title")
        }
      );
    })
    .catch((err) => {
      console.log("err", err);

      actions.setValue(
        EVOUCHER,
        {
          isLoadingAction: false,
          showModal: false
        }
      );

      this.refreshTable();
    });
  }

  deleteData () {
    let {
      EVoucher,
      actions
    } = this.props;

    let {
      selectedData
    } = EVoucher;

    actions.setValue(EVOUCHER, { isLoadingAction: true });

    if (IS_VALID(selectedData)) {
      selectedData.set("isDeleted", true);

      selectedData.save()
      .then((data) => {
        actions.setValue(
          EVOUCHER,
          {
            isLoadingAction: false,
            showModal: false
          }
        );

        this.refreshTable();

        saveTrail(
          "DELETE",
          {
            objectId: selectedData.id,
            title: selectedData.get("title") || "",
            descriptions: selectedData.get("descriptions") || ""
          }
        );
      })
      .catch((err) => {
        console.log("deleteData error: err");

        actions.setValue(
          EVOUCHER,
          {
            isLoadingAction: false,
            showModal: false
          }
        );

        this.refreshTable();
      });
    }
  }

  renderModalButton () {
    let {
      EVoucher,
      actions
    } = this.props;

    let {
      selectedData,
      formType,
      isLoadingAction,
      isUploadingCSVFile,
      isUploadingCSVFileBlacklistedUser,
      isUploadingCSVFileEVScannerUser,
      isStatusExpired
    } = EVoucher;

    let status = formType !== "DUPLICATE" && IS_VALID(selectedData) ? selectedData.get("status") : "";

    let buttonSave = (
      <Button
        bsStyle="primary"
        disabled={isLoadingAction || isUploadingCSVFile || isUploadingCSVFileBlacklistedUser || isUploadingCSVFileEVScannerUser}
        onClick={() => this.save()}
        >
        {status === "PUBLISH" || status === "EXPIRED" || status === "SUSPENDED" ? "UPDATE" : "PUBLISH"}
      </Button>
    );

    // <OverlayTrigger
    //   trigger="click"
    //   rootClose
    //   placement="top"
    //   overlay={
    //     <Popover
    //       title="Publish this EVoucher?"
    //       style={{ textAlign: "center" }}
    //       >
    //       <p>Once a EVoucher is published, altering of data is no longer allowed.</p>
    //       <Button
    //         bsStyle="primary"
    //         disabled={isLoadingAction}
    //         onClick={() => this.save()}
    //         >
    //         CONFIRM
    //       </Button>
    //     </Popover>
    //   }>
    //   <Button
    //     bsStyle="primary"
    //     disabled={isLoadingAction}
    //     >
    //     {status === "PUBLISH" ? "UPDATE" : "PUBLISH"}
    //   </Button>
    // </OverlayTrigger>

    let buttonSaveAsDraft = (
      <Button
        onClick={() => this.save(true)}
        disabled={isLoadingAction || isUploadingCSVFile || isUploadingCSVFileBlacklistedUser || isUploadingCSVFileEVScannerUser}
        >
        SAVE AS DRAFT
      </Button>
    );

    let buttonDelete = (
      <Button
        bsStyle="primary"
        onClick={() => this.deleteData()}
        disabled={isLoadingAction}
        >
        {isLoadingAction ? <span><i className="fa fa-spinner fa-spin" style={{ color: "white" }}></i>&nbsp;</span> : ''}
        DELETE
      </Button>
    );

    let buttonSuspend = (
      <Button
        bsStyle="primary"
        onClick={() => this.suspendData()}
        disabled={isLoadingAction}
        >
        {isLoadingAction ? <span><i className="fa fa-spinner fa-spin" style={{ color: "white" }}></i>&nbsp;</span> : ''}
        SUSPEND
      </Button>
    );

    let buttonUnsuspend = (
      <Button
        bsStyle="primary"
        onClick={() => this.unsuspendData()}
        disabled={isLoadingAction}
        >
        {isLoadingAction ? <span><i className="fa fa-spinner fa-spin" style={{ color: "white" }}></i>&nbsp;</span> : ''}
        UNSUSPEND
      </Button>
    );

    let buttonClose = (
      <Button
        disabled={isLoadingAction || isUploadingCSVFile || isUploadingCSVFileBlacklistedUser || isUploadingCSVFileEVScannerUser}
        onClick={() => {
          if (!isLoadingAction) {
            actions.setValue(
              EVOUCHER,
              {
                showModal: false
              }
            );
          }
        }}>
        CLOSE
      </Button>
    );

    switch (formType.toUpperCase()) {
      case "CREATE":
      case "DUPLICATE":
        return <span>{buttonSave}{buttonSaveAsDraft}{buttonClose}</span>;
        break;
      case "UPDATE":
        if (isStatusExpired) {
          return (
            <span>
              {buttonClose}
            </span>
          );
        }
        return (
          <span>
            {buttonSave}
            {status === "PUBLISH" || status === "EXPIRED" || status === "SUSPENDED" ? (
              ""
            ) : (
              buttonSaveAsDraft
            )}
            {buttonClose}
          </span>
        );
        break;
      case "VIEW":
        return buttonClose;
        break;
      case "DELETE":
        return <span>{buttonDelete}{buttonClose}</span>
        break;
      case "SUSPEND":
        return <span>{buttonSuspend}{buttonClose}</span>
        break;
      case "UNSUSPEND":
        return <span>{buttonUnsuspend}{buttonClose}</span>
        break;
      default:
        return "";
    }
    return "";
  }

  getVoucherConfig () {
    let {
      actions
    } = this.props;

    let voucherConfigQuery = new Parse.Query("VoucherConfig");

    actions.setValue(EVOUCHER, { isLoadingConfig: true });
    voucherConfigQuery.first()
    .then((config) => {
      let stateToUpdate = {
        isLoadingConfig: false
      };

      if (IS_VALID(config)) {
        stateToUpdate.isActive = IS_VALID(config.get("isActive")) ? config.get("isActive") : true;
        stateToUpdate.configParseObject = config;
      } else {
        stateToUpdate.isActive = true;
      }

      actions.setValue(EVOUCHER, stateToUpdate);
    })
    .catch((err) => {
      actions.setValue(EVOUCHER, { isLoadingConfig: false });
      console.log("getVoucherConfig error: ", err);
    });
  }

  getVoucherUpdateLogs () {
    let {
      actions
    } = this.props;

    let voucherUpdateLogsQuery = new Parse.Query("VoucherUpdateLogs");

    voucherUpdateLogsQuery.descending("createdAt");

    actions.setValue(EVOUCHER, { isLoadingVoucherLog: true });

    voucherUpdateLogsQuery.first()
    .then((voucherUpdateLogs) => {
      let stateToUpdate = {
        isLoadingVoucherLog: false
      };

      if (IS_VALID(voucherUpdateLogs)) {
        stateToUpdate.pointsLastUpdate = "Last Update: " + moment(voucherUpdateLogs.get("startTime")).format("MMM DD, YYYY hh:mm A");
      } else {
        stateToUpdate.pointsLastUpdate = "No updates.";
      }

      actions.setValue(EVOUCHER, stateToUpdate);
    })
    .catch((err) => {
      console.log("getVoucherUpdateLogs error: ", err);
      actions.setValue(
        EVOUCHER,
        {
          isLoadingVoucherLog: false,
          pointsLastUpdate: "No updates."
        }
      );
    });
  }

  renderModalConfigContent () {
    let {
      EVoucher,
      actions
    } = this.props;

    let {
      isActive,
      message
    } = EVoucher;

    let formComponent = (
      <FormGroup>
        <ControlLabel>Message</ControlLabel>
        <FormControl
          componentClass="textarea"
          value={message}
          onChange={(e) => {
            actions.setValue(EVOUCHER, { message: e.target.value });
          }}/
          >
      </FormGroup>
    );

    return (
      <div>
        {isActive ? (
          formComponent
        ) : (
          "Are you sure you want to activate Voucher Module?"
        )}
      </div>
    );
  }

  saveVoucherConfig () {
    let {
      EVoucher,
      actions
    } = this.props;

    let {
      isActive,
      message,
      configParseObject
    } = EVoucher;

    actions.setValue(EVOUCHER, { isSaving: true });

    new Promise((resolve, reject) => {
      if (IS_VALID(configParseObject)) {
        resolve(configParseObject);
      } else {
        let query = new Parse.Query("VoucherConfig");

        query.first()
        .then(resolve)
        .catch(reject);
      }
    })
    .then((config) => {
      configParseObject = config;

      if (IS_UNDEFINED(config)) {
        configParseObject = new Parse.Object("VoucherConfig");
      }

      configParseObject.set("isActive", !isActive);

      if (!isActive === false && IS_VALID(message)) {
        configParseObject.set("message", message);
      } else {
        configParseObject.unset("message");
      }

      return configParseObject.save();
    })
    .then((data) => {
      let stateToUpdate = {
        isSaving: false,
        isActive: !isActive,
        message: "",
        showConfigModal: false,
        configParseObject: data
      };

      actions.setValue(EVOUCHER,  stateToUpdate);
    })
    .catch((err) => {
      console.log("saveVoucherConfig error: ", err);

      actions.setValue(
        EVOUCHER,
        {
          isSaving: false,
          message: "",
          showConfigModal: false
        }
      );
    });
  }

  uploadSpecificUserCSVFile (csvFile, stateName) {
    console.log("stateName", stateName)
    let {
      EVoucher,
      actions
    } = this.props;

    let selectUserStateArray = EVoucher[stateName],
        loadingState = stateName === "blacklistedUser" ? "isUploadingCSVFileBlacklistedUser" : stateName === "evScannerUser" ? "isUploadingCSVFileEVScannerUser" : "isUploadingCSVFile";

    actions.setValue(
      EVOUCHER,
      {
        [loadingState]: true
      }
    );

    let fd = new FormData();

    fd.append("csvFile", csvFile);

    axios.post(
      WEB_PATH + (stateName === "evScannerUser" ? "/EVScanner/upload" : "/MemberDetail/upload"),
      fd
    )
    .then((res) => {
      let {
        data
      } = res;

      let updatedUserArray = [...selectUserStateArray];

      for (let item of data) {
        if (updatedUserArray.map((item) => item.value).indexOf(item.objectId) === -1) {
          updatedUserArray.push({
            label: stateName === "evScannerUser" ? `${IS_VALID(item.name) ? item.name : ""}` : `${IS_VALID(item.memberId) ? item.memberId : ""} ${IS_VALID(item.name) ? item.name : ""}`,
            value: item.objectId
          });
        }
      }

      actions.setValue(
        EVOUCHER,
        {
          [loadingState]: false,
          [stateName]: updatedUserArray
        }
      )
    })
    .catch((err) => {
      console.log("uploadSpecificUserCSVFile error: ", err);

      actions.setValue(
        EVOUCHER,
        {
          [loadingState]: false
        }
      )
    });
  }

  runCronJobs () {
    let {
      actions
    } = this.props;

    actions.setValue(
      EVOUCHER,
      {
        isLoadingCronJobs: true
      }
    );

    axios({
      method: "post",
      url: WEB_PATH + "/api/points/update",
      data: {
        api_key: API_KEY
      }
    })
    .then((res) => {
      actions.setValue(
        EVOUCHER,
        {
          isLoadingCronJobs: false
        }
      );

      this.getVoucherUpdateLogs();
    })
    .catch((err) => {
      console.log("runCronJobs error: ", err);

      actions.setValue(
        EVOUCHER,
        {
          isLoadingCronJobs: false
        }
      );
    });
  }

  checkEVoucherStatus () {
    const {
      EVoucher,
      actions
    } = this.props;

    const {
      selectedData
    } = EVoucher;

    actions.setValue(
      EVOUCHER,
      {
        isCheckingEVoucherStatus: true
      }
    );

    selectedData.fetch()
    .then((data) => {
      actions.setValue(
        EVOUCHER,
        {
          isCheckingEVoucherStatus: false,
          isStatusExpired: data.get('status') === 'EXPIRED'
        }
      );
    })
    .catch((err) => {
      actions.setValue(
        EVOUCHER,
        {
          isCheckingEVoucherStatus: false
        }
      );
    });
  }

accessible (actionType) {
		let {
			access
		} = this.props.accessjson;

		if (access.length !== 0) {
			var currentPath = window.location.pathname,
					index = access.map((module) => module.route.toUpperCase()).indexOf(currentPath.toUpperCase()),
					actions = [];

			if (access[index]) {
				actions = access[index].actions
			}

			if (actions.length != 0) {
				if (actions.indexOf(actionType.toUpperCase()) === -1) {
					return 'none';
				} else {
					return '';
				}
			} else {
	      return 'none';
	    }
		} else {
			return 'none';
		}
	}

  render () {
    let {
      EVoucher,
      accessjson,
      actions
    } = this.props;

    let {
      showModal,
      formType,
      isLoadingAction,
      isUploadingCSVFile,
      isUploadingCSVFileBlacklistedUser,
      isUploadingCSVFileEVScannerUser,
      isLoadingCronJobs,

      showConfigModal,
      isLoadingConfig,
      isSaving,
      isActive,
      configParseObject,

      isLoadingVoucherLog,
      pointsLastUpdate,
      birthMonthOptions,
      genderOptions
    } = EVoucher;

    let customUpdate = (obj, formType = "UPDATE") => {
      let stateToUpdate = {
        showModal: true,
        formType: formType,
        formId: obj.id,
        selectedData: obj
      };

      if (IS_VALID(obj.get("typeK"))) {
        stateToUpdate.typeK = {
          label: obj.get("typeK").get("name"),
          value: obj.get("typeK").id,
          shortName: obj.get("typeK").get("shortName")
        }
      }

      if (IS_VALID(obj.get("gender"))) {
        let genderIndex = genderOptions.map((item) => item.value).indexOf(obj.get("gender").toUpperCase());

        let gender;

        if (genderIndex !== -1) {
          gender = genderOptions[genderIndex];
        } else {
          gender = genderOptions[0];
        }

        stateToUpdate.gender = gender;
      }

      if (IS_VALID(obj.get("pointType"))) {
        stateToUpdate.pointType = {
          label: obj.get("pointType").get("name"),
          value: obj.get("pointType").id
        }
      }
      if (IS_VALID(obj.get("deductPointType"))) {
        stateToUpdate.deductPointType = {
          label: obj.get("deductPointType").get("name"),
          value: obj.get("deductPointType").id
        }
      }
      if (IS_VALID(obj.get("earningPeriod"))) {
        stateToUpdate.earningPeriod = {
          label: obj.get("earningPeriod").get("name"),
          value: obj.get("earningPeriod").id
        }
      }
      if (IS_VALID(obj.get("earningPeriodStartDate"))) {
        stateToUpdate.earningPeriodStartDate = moment(obj.get("earningPeriodStartDate"));
      }
      if (IS_VALID(obj.get("earningPeriodEndDate"))) {
        stateToUpdate.earningPeriodEndDate = moment(obj.get("earningPeriodEndDate"));
      }
      if (IS_VALID(obj.get("welcomeDays"))) {
        stateToUpdate.welcomeDays = obj.get("welcomeDays");
      }
      if (IS_VALID(obj.get("voucherValidityDays"))) {
        stateToUpdate.voucherValidityDays = obj.get("voucherValidityDays");
      }
      if (IS_VALID(obj.get("voucherValidityType"))) {
        stateToUpdate.voucherValidityType = {
          label: obj.get("voucherValidityType").get("name"),
          value: obj.get("voucherValidityType").id,
          shortName: obj.get("voucherValidityType").get("shortName")
        };
      }

      if (IS_VALID(obj.get("voucherValidityTimeConfig"))) {
        let timeConfig = obj.get("voucherValidityTimeConfig");

        if (IS_VALID(timeConfig.hour)) {
          stateToUpdate.voucherValidityHour = timeConfig.hour;
        }

        if (IS_VALID(timeConfig.minute)) {
          stateToUpdate.voucherValidityMinute = timeConfig.minute;
        }

        if (IS_VALID(timeConfig.second)) {
          stateToUpdate.voucherValiditySecond = timeConfig.second;
        }

        let month = moment().month(),
            date = moment().date(),
            year = moment().year();

        if (IS_VALID(timeConfig.start)) {
          stateToUpdate.voucherValidityStartTime = moment(timeConfig.start, "hh:mm A", true).month(month).date(date).year(year);
        }

        if (IS_VALID(timeConfig.end)) {
          stateToUpdate.voucherValidityEndTime = moment(timeConfig.end, "hh:mm A", true).month(month).date(date).year(year);
        }
      }

      if (IS_VALID(obj.get("voucherValidityStartDate"))) {
        stateToUpdate.voucherValidityStartDate = moment(obj.get("voucherValidityStartDate"));
      }

      if (IS_VALID(obj.get("voucherValidityEndDate"))) {
        stateToUpdate.voucherValidityEndDate = moment(obj.get("voucherValidityEndDate"));
      }

      if (IS_VALID(obj.get("voucherValidityIsUseCalendarDay"))) {
        stateToUpdate.voucherValidityIsUseCalendarDay = obj.get("voucherValidityIsUseCalendarDay") || false;
      }

      if (IS_VALID(obj.get("birthMonth"))) {
        let birthMonthIndex = birthMonthOptions.map(({ value }) => value).indexOf(obj.get("birthMonth"));

        if (birthMonthIndex !== -1) {
          stateToUpdate.birthMonth = birthMonthOptions[birthMonthIndex];
        }
      }

      if (IS_VALID(obj.get("tdd_birthMonthStartDate"))) {
        stateToUpdate.tdd_birthMonthStartDate = moment(obj.get("tdd_birthMonthStartDate"));
      }

      if (IS_VALID(obj.get("tdd_birthMonthEndDate"))) {
        stateToUpdate.tdd_birthMonthEndDate = moment(obj.get("tdd_birthMonthEndDate"));
      }

      if (IS_VALID(obj.get("campaignStartDate"))) {
        stateToUpdate.campaignStartDate = moment(obj.get("campaignStartDate"));
      }
      if (IS_VALID(obj.get("campaignEndDate"))) {
        stateToUpdate.campaignEndDate = moment(obj.get("campaignEndDate"));
      }
      if (IS_VALID(obj.get("requiredEarningAmount"))) {
        stateToUpdate.requiredEarningAmount = obj.get("requiredEarningAmount");
      }
      if (IS_VALID(obj.get("deductPointAmount"))) {
        stateToUpdate.deductPointAmount = obj.get("deductPointAmount");
      }
      if (IS_VALID(obj.get("maxVoucherQuantity"))) {
        stateToUpdate.maxVoucherQuantity = obj.get("maxVoucherQuantity");
      }
      if (IS_VALID(obj.get("maxVoucherQuantityPerDay"))) {
        stateToUpdate.maxVoucherQuantityPerDay = obj.get("maxVoucherQuantityPerDay");
      }
      if (IS_VALID(obj.get("maxVoucherQuantityPerUser"))) {
        stateToUpdate.maxVoucherQuantityPerUser = obj.get("maxVoucherQuantityPerUser");
      }
      if (IS_VALID(obj.get("maxVoucherQuantityPerUserPerDay"))) {
        stateToUpdate.maxVoucherQuantityPerUserPerDay = obj.get("maxVoucherQuantityPerUserPerDay");
      }
      if (IS_VALID(obj.get("version"))) {
        stateToUpdate.version = {
          label: obj.get("version") === 1 ? "Version 1" : "Version 2",
          value: obj.get("version")
        };
      }
      if (IS_VALID(obj.get("campaignCategory"))) {
        stateToUpdate.campaignCategory = obj.get("campaignCategory");
      }
      if (IS_VALID(obj.get("title"))) {
        stateToUpdate.title = obj.get("title");
      }
      if (IS_VALID(obj.get("promotionName"))) {
        stateToUpdate.promotionName = obj.get("promotionName");
      }
      if (IS_VALID(obj.get("descriptions"))) {
        stateToUpdate.descriptions = obj.get("descriptions");
      }
      if (IS_VALID(obj.get("whereToRedeem"))) {
        stateToUpdate.whereToRedeem = obj.get("whereToRedeem");
      }
      if (IS_VALID(obj.get("serialNumberPrefix"))) {
        stateToUpdate.serialNumberPrefix = obj.get("serialNumberPrefix");
      }
      if (IS_VALID(obj.get("amount"))) {
        stateToUpdate.amount = obj.get("amount");
      }
      if (IS_VALID(obj.get("promoOwnerCostCenter"))) {
        stateToUpdate.promoOwnerCostCenter = obj.get("promoOwnerCostCenter");
      }
      if (IS_VALID(obj.get("promoCategory"))) {
        stateToUpdate.promoCategory = {
          label: obj.get("promoCategory").get("name"),
          value: obj.get("promoCategory").id
        };
      }
      if (IS_VALID(obj.get("nnsl_amount"))) {
        stateToUpdate.nnsl_amount = obj.get("nnsl_amount");
      }
      if (IS_VALID(obj.get("nnc_amount"))) {
        stateToUpdate.nnc_amount = obj.get("nnc_amount");
      }
      if (IS_VALID(obj.get("image"))) {
        stateToUpdate.image = { preview: obj.get("image").url(), isOld: true };
      }
      if (IS_VALID(obj.get("isShowForFirstTimeUsers"))) {
        stateToUpdate.isShowForFirstTimeUsers = obj.get("isShowForFirstTimeUsers");
      }
      if (IS_VALID(obj.get("isShowRemainingQuantity"))) {
        stateToUpdate.isShowRemainingQuantity = obj.get("isShowRemainingQuantity");
      }

      if (IS_VALID(obj.get("isRateRequired"))) {
        stateToUpdate.isRateRequired = obj.get("isRateRequired");
      }

      if (IS_VALID(obj.get("isShowMerchantsOwnRedemptionOnly"))) {
        stateToUpdate.isShowMerchantsOwnRedemptionOnly = obj.get("isShowMerchantsOwnRedemptionOnly");
      }

      if (IS_VALID(obj.get("rateTimeConfig"))) {
        let timeConfig = obj.get("rateTimeConfig");

        if (IS_VALID(timeConfig.hour)) {
          stateToUpdate.rateTimeConfigHour = timeConfig.hour;
        }

        if (IS_VALID(timeConfig.minute)) {
          stateToUpdate.rateTimeConfigMinute = timeConfig.minute;
        }

        if (IS_VALID(timeConfig.second)) {
          stateToUpdate.rateTimeConfigSecond = timeConfig.second;
        }
      }

      actions.setValue(EVOUCHER, stateToUpdate);
    };

    let crudProps = {
      schema: EVoucherSchema,
      moduleQuery: [
        { method: "descending", column: "createdAt" }
      ],
      access: accessjson.access,
      saveTrail: saveTrail,
      customView: (obj) => {
        actions.setValue(
          EVOUCHER,
          {
            showModal: true,
            formType: "VIEW",
            selectedData: obj
          }
        );
      },
      customCreate: () => {
        actions.setValue(
          EVOUCHER,
          {
            showModal: true,
            formType: "CREATE"
          }
        );
      },
      customUpdate: customUpdate,
      customDelete: (obj) =>{
        actions.setValue(
          EVOUCHER,
          {
            showModal: true,
            formType: "DELETE",
            formId: obj.id,
            selectedData: obj
          }
        );
      },
      customAction: ({ object, buttonView, buttonUpdate, buttonDelete }) => {
        let isManageOwn = this.accessible("MANAGE OWN") === "";

        let _updateBtn = '',
            _deleteBtn = "";

        if (
          !(
            this.accessible("MANAGE OWN") === "" &&
            (
              !IS_VALID(object.get("createdBy")) ||
              object.get("createdBy").id !== Parse.User.current().id
            )
          )
        ) {
          _updateBtn = buttonUpdate;
          _deleteBtn = buttonDelete;
        }

        let _suspendBtn = "",
            suspendBtn = (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Suspend</Tooltip>}
            >
            <a
              className="fa fa-ban fa-lg"
              href="javascript:void(0)"
              onClick={() => {
                actions.setValue(
                  EVOUCHER,
                  {
                    showModal: true,
                    formType: "SUSPEND",
                    formId: object.id,
                    selectedData: object
                  }
                );
              }}
            />
          </OverlayTrigger>
        );

        if (
          this.accessible("SUSPEND") === "" &&
          (
            object.get("status") === "PUBLISH"
            // ||
            // object.get("status") === "EXPIRED"
          )
        ) {
          if (
            !(
              isManageOwn &&
              (
                !IS_VALID(object.get("createdBy")) ||
                object.get("createdBy").id !== Parse.User.current().id
              )
            )
          ) {
            _suspendBtn = suspendBtn;
          }
        }

        let _unsuspendBtn = "",
            unsuspendBtn = (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Unsuspend</Tooltip>}
            >
            <a
              className="fa fa-undo fa-lg"
              href="javascript:void(0)"
              onClick={() => {
                actions.setValue(
                  EVOUCHER,
                  {
                    showModal: true,
                    formType: "UNSUSPEND",
                    formId: object.id,
                    selectedData: object
                  }
                );
              }}
            />
          </OverlayTrigger>
        );

        if (
          this.accessible("UNSUSPEND") === "" &&
          object.get("status") === "SUSPENDED"
        ) {
          if (
            !(
              isManageOwn &&
              (
                !IS_VALID(object.get("createdBy")) ||
                object.get("createdBy").id !== Parse.User.current().id
              )
            )
          ) {
            _unsuspendBtn = unsuspendBtn;
          }
        }
        
        if (
          object.get('status') === 'EXPIRED'
        ) {
          _updateBtn = '';
        }

        return (
          <span>
            {buttonView}
            {_updateBtn}
            {this.accessible("DUPLICATE") === "" ? (
              <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Duplicate</Tooltip>}
                  >
                  <a
                    className="fa fa-copy fa-lg"
                    href="javascript:void(0)"
                    onClick={() => customUpdate(object, "DUPLICATE")}
                  />
                </OverlayTrigger>
            ) : (
              ""
            )}
            {_suspendBtn}
            {_unsuspendBtn}
            {_deleteBtn}
          </span>
        );
      },
      refreshTable: (refreshTable) => {
        this.refreshTableReference = refreshTable;
      },
      customItems: [
        {
          columnName: "title",
          render: ({value, column, getTableData, object}) => {
            let renderValue = "";

            if (IS_VALID(value)) {
              renderValue = value.substr(0, 100).trim() + (value.length <= 100 ? "" : "...");
            }

            return renderValue;
          }
        },
        {
          columnName: "descriptions",
          render: ({value, column, getTableData, object}) => {
            let renderValue = "";

            if (IS_VALID(value)) {
              renderValue = value.substr(0, 60).trim() + (value.length <= 60 ? "" : "...");
            }

            return renderValue;
          }
        },
        {
          columnName: "whereToRedeem",
          render: ({value, column, getTableData, object}) => {
            let renderValue = "";

            if (IS_VALID(value)) {
              renderValue = value.substr(0, 100).trim() + (value.length <= 100 ? "" : "...");
            }

            return renderValue;
          }
        },
        {
          columnName: "status",
          render: ({value, column, getTableData, object}) => {
            let renderValue = value;

            if (IS_VALID(value)) {
              switch (value.toUpperCase()) {
                case "PUBLISH":
                  renderValue = <span style={{ color: "green" }}>{value}</span>;
                  break;
                case "EXPIRED":
                  renderValue = <span style={{ color: "red" }}>{value}</span>
                  break;
                case "DRAFT":
                  renderValue = <span style={{ color: "gray" }}>{value}</span>
                  break;
              }
            }

            return renderValue;
          }
        }
      ],
      customExport: ({ className, queryJson }, cb) => {
        this.setState({
          showModalExport: true
        });

        cb();
      }
    };

    let formContainerProps = {
      ...this.props,
      loadOptions: this.loadOptions,
      getRelation: this.getRelation,
      uploadSpecificUserCSVFile: this.uploadSpecificUserCSVFile,
      checkEVoucherStatus: this.checkEVoucherStatus,
      formType
    };

    let buttonConfig = (
      <Button
        bsStyle={isLoadingConfig ? (null) : (isActive ? "success" : "danger")}
        disabled={isLoadingConfig}
        onClick={() => {
          actions.setValue(EVOUCHER, { showConfigModal: true });
        }}
        >
        {isLoadingConfig ? (
          <i className="fa fa-spinner fa-spin"/>
        ) : (
          isActive ? "ACTIVE" : "INACTIVE"
        )}
      </Button>
    );

    let renderButtonConfig = buttonConfig;

    if (IS_VALID(configParseObject) && (IS_VALID(configParseObject.get("isActive")) && configParseObject.get("isActive") === false) && IS_VALID(configParseObject.get("message"))) {
      renderButtonConfig = (
        <OverlayTrigger
          placement="top"
          overlay={
            <Popover>
              {configParseObject.get("message")}
            </Popover>
          }
          >
          {buttonConfig}
        </OverlayTrigger>
      );
    }

    return (
      <div>
        <Panel>
          <Panel.Heading style={{
            backgroundColor: '#D1282F',
            color: 'white'
          }}>
            <h4 style={{ display: "inline-block" }}>{EVoucherSchema.classNameLabel.toUpperCase()}</h4>
            <div
              style={{ float: "right" }}>
              {renderButtonConfig}
              &nbsp;&nbsp;&nbsp;
              <OverlayTrigger
                placement="top"
                overlay={
                  <Popover>
                    {isLoadingVoucherLog || isLoadingCronJobs ? (
                      <i className="fa fa-spinner fa-spin"/>
                    ) : (
                      pointsLastUpdate
                    )}
                  </Popover>
                }
                >
                <Button
                  disabled={isLoadingCronJobs}
                  onClick={() => this.runCronJobs()}
                  >
                  {isLoadingCronJobs ? (
                    <i className="fa fa-spinner fa-spin"/>
                  ) : (
                    "UPDATE POINTS"
                  )}
                </Button>
              </OverlayTrigger>
            </div>
          </Panel.Heading>
          <Panel.Body>
            <CrudComponent {...crudProps}/>
          </Panel.Body>
        </Panel>
        <Modal
          bsSize={formType.toUpperCase() === "DELETE" || formType.toUpperCase() === "SUSPEND" || formType.toUpperCase() === "UNSUSPEND" ? null : "large"}
          show={showModal}
          backdrop="static"
          onHide={() => {
            if (!isLoadingAction || !isUploadingCSVFile || isUploadingCSVFileBlacklistedUser || isUploadingCSVFileEVScannerUser) {
              actions.setValue(EVOUCHER, { showModal: false })
            }
          }}>
          <Modal.Header closeButton>
            <Modal.Title>{formType.toUpperCase()}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormContainer {...formContainerProps}/>
          </Modal.Body>
          <Modal.Footer>
            {this.renderModalButton()}
          </Modal.Footer>
        </Modal>
        <Modal
          show={showConfigModal}
          onHide={() => {
            if (!isSaving) {
              actions.setValue(EVOUCHER, { showConfigModal: false })
            }
          }}
          bsSize="small"
          >
          <Modal.Header closeButton>
            <h4>{isActive ? "DEACTIVATE " : "ACTIVATE "}VOUCHER</h4>
          </Modal.Header>
          <Modal.Body>
            {this.renderModalConfigContent()}
          </Modal.Body>
          <Modal.Footer>
            <Button
              bsStyle={isActive ? "danger" : "success"}
              disabled={isSaving}
              onClick={() => this.saveVoucherConfig()}
            >
              {isActive ? "DEACTIVATE" : "ACTIVATE"}
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          bsSize={null}
          backdrop="static"
          show={this.state.showModalExport}
          onHide={() => {
              if (
                this.exportComponentRef.current &&
                this.exportComponentRef.current.isLoading()
              ) {
                return;   
              }
              
              this.setState({
                showModalExport: false
              });
          }}
        >
            <Modal.Header closeButton>
                <Modal.Title>EXPORT EVOUCHER</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ExportComponent
                ref={this.exportComponentRef}
                closeModal={() => {
                    this.setState({ showModalExport: false });
                }}
              />
            </Modal.Body>
        </Modal>
        <ToastContainer />
      </div>
    );
  }

  componentDidMount () {
    this.getVoucherConfig();
    this.getVoucherUpdateLogs();
  }
}

class ExportComponent extends Component {
  constructor (props) {
    super(props);
  
    this.state = {
      password: "",

      isExportStarting: false,
      isExporting: false,
      isExportSuccess: false,
      isExportError: false,
      exportPercentage: 0,
      fileConfig: {
          filename: "",
          blob: ""
      },
      errorMessage: ""
    };

    this.exportData = this.exportData.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
    this.isLoading = this.isLoading.bind(this);
  }

  exportData () {
    let {
      password
    } = this.state;

    if (
      false
      //!IS_VALID(password) ||
      //!IS_VALID(password.trim())
    ) {
        toast.error("Excel File Password is required.");
    } else {
      this.setState({
        isExportStarting: true
      });

      let params = {
      //  password: password.trim()
      };

      axios.post(
        WEB_PATH + "/EVoucher/export",
        params,
        {
            timeout: 30000
        }
      )
      .then((res) => {
        let {
          fileName,
          socketNspId
        } = res.data;

        this.setState({
          isExportStarting: false,
          isExporting: true
        });

        let io = socketIOClient(
          WEB_PATH,
          {
              transports: ["websocket"],
              path: "/socket.io",
              query: {
                  nspId: socketNspId
              },
              secure: true
          }
        );

        let listenerName = "export-evoucher-socket";

        io.on(
          listenerName,
          (data) => {
              let {
                  status,
                  progress,
                  fileName,
                  message
              } = data;
              if (status === "PROGRESS") {
                  this.setState({
                      exportPercentage: progress
                  });
              } else if (status === "DONE") {
                  io.off(listenerName);
                  io.close();
                  
                  axios.get(
                    WEB_PATH + "/EVoucher/download/" + fileName,
                     {
                          responseType: "arraybuffer"
                      }
                  )
                  .then((res2) => {
                      let blob = new Blob([res2.data], { type: "application/vnd.ms-excel" }),
                          filename = `EVoucher ${moment().format("MMM DD YYYY hh:mm A")}.xlsx`;
      
                      this.setState({
                          isExporting: false,
                          isExportSuccess: true,
                          exportPercentage: 100,
                          fileConfig: {
                          filename: filename,
                          blob: blob
                          }
                      });
      
                      FileSaver.saveAs(blob, filename);
                  })
                  .catch((err) => {
                      let errorMessage = err.message;
      
                      if (
                          err.response &&
                          err.response.data &&
                          ("TextDecoder" in window)
                      ) {
                          let enc = new TextDecoder("utf-8");
                          let arr = new Uint8Array(err.response.data);
                          
                          let data = JSON.parse(enc.decode(arr)) || {};
      
                          if (
                              data.error &&
                              data.error.message
                          ) {
                              errorMessage = data.error.message;
                          }
                      }
                      
                      this.setState({
                          isExporting: false,
                          isExportError: true,
                          errorMessage
                      });
                  });
              } else if (status === "ERROR") {
                  io.off(listenerName);
                  io.close();
                  
                  this.setState({
                      isExporting: false,
                      isExportError: true,
                      errorMessage: message
                  });
              }
          }
        );
      })
      .catch((err) => {
        let errorMessage = err.message;

        if (
            err.response &&
            err.response.data &&
            typeof err.response.data === "string"
        ) {
            errorMessage = err.response.data;
        }

        this.setState({
            isExportStarting: false,
            isExportError: true,
            errorMessage
        });
      });
    }
  }

  downloadFile () {
    let {
        fileConfig
    } = this.state;

    let {
        filename,
        blob
    } = fileConfig

    if (IS_VALID(filename) && IS_VALID(blob)) {
        FileSaver.saveAs(blob, filename);
    }
  }

  isLoading () {
    let {
        isExportStarting,
        isExporting
    } = this.state;

    return isExportStarting || isExporting;
  }

  render () {
    let {
      password,

      isExportStarting,
      isExporting,
      isExportSuccess,
      isExportError,
      exportPercentage,
      errorMessage
    } = this.state;

    let {
        closeModal
    } = this.props;

    return (
      <div>
        {
          !isExporting &&
          !isExportSuccess &&
          !isExportError ? (
            [
              <p>Exporting of EVoucher may take some time depending on the number of records.</p>,
              //<p>Note: The export files will be password protected with the recommended password below. </p>,
              //<Form inline>
              //  <FormGroup>
              //    <ControlLabel>Recommended Password<span style={{ color: "red" }}>*</span>:&nbsp;</ControlLabel>
              //    <FormControl
              //      disabled={isExportStarting}
              //      value={password}
              //      onChange={(e) => {
              //        if (!isExportStarting) {
              //            this.setState({ password: e.target.value });
              //        }
              //      }}
              //    />
              //  </FormGroup>
              //</Form>,
              <br/>,
              <br/>,
              <div style={{ textAlign: "center" }}>
                <Button  
                  className="btn-primary"
                  disabled={isExportStarting}
                  onClick={() => {
                    this.exportData()
                  }}>
                  {isExportStarting ? <span><i className="fa fa-spinner fa-spin" style={{ color: "white" }} /> </span> : ""}  EXPORT
                  </Button>
              </div>
            ]
          ) : (
            ""
          )
        }
        {
          isExporting ? (
            [
              <p>This may take some time depending on the number of records.</p>,
              <ProgressBar
                active
                striped
                bsStyle="success"
                now={exportPercentage}
                label={`${exportPercentage}%`}
              />
            ]
          ) : isExportSuccess || isExportError ? (
            isExportSuccess ? (
              <div style={{ textAlign: "center" }}>
                  <Button
                      bsStyle="success"
                      content="DOWNLOAD FILE"
                      onClick={this.downloadFile}
                  >
                      DOWNLOAD FILE
                  </Button>
              </div>
            ) : (
              [
                <h3 style={{ textAlign: "center", color: "red" }}>Something went wrong.</h3>,
                <h4 style={{ textAlign: "center"}}>{errorMessage}</h4>,
                <div style={{ textAlign: "center" }}>
                  <Button
                    bsStyle="primary"
                    onClick={() => {
                      closeModal();
                    }}>
                    CLOSE
                  </Button>
                </div>
              ]
            )
          ) : (
            ""
          )
        }
      </div>
    );
  }
  
  componentDidMount () {
    this.setState({
        password: GENERATE_RANDOM(10, "string")
    });
  }
}
import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';

function mapStateToProps(state) {
	var {
		accessjson,
    EVoucher
	} = state;

	const props = {
		accessjson,
    EVoucher
	};
	return props;
}

function mapDispatchToProps(dispatch) {
  const actions = {
    setValue: generics.setValue
  };

  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EVoucher);



// WEBPACK FOOTER //
// ./components/EVoucher/index.js